export * from "./channel";

import { get } from "lodash-es";
import bus from "vue3-eventbus";

import { useToggles } from "@/hooks/useToggles";
import { useUserStoreHook } from "@/store/modules/user";

const getShowCustomConfirmation = () => {
  const userStore = useUserStoreHook();
  const showCustomConfirmation = useToggles(
    "Y_CONFIRMATION_LETTER_CONFIGURABLE"
  );
  const level = get(
    userStore.user,
    "hierarchyCommissionSplitting.semanticLevel",
    0
  );
  return (
    userStore.user?._id && level && level !== 9 && showCustomConfirmation.value
  );
};

/**
 * 顶部登录后头像下拉菜单配置
 */
export const headerSettings = [
  {
    label: "shell.common.orderList",
    path: "/orders"
  },
  {
    label: "shared.common.autoSendConfirmationLetter",
    key: "sendWhenBooking",
    component: {
      name: "ElSwitch",
      modelValue: false,
      events: {
        change: val => {
          const userStore = useUserStoreHook();
          userStore.updateUserToggle([
            {
              key: "confirmationLetter.sendWhenBooking",
              value: val
            }
          ]);
        }
      }
    },
    show: getShowCustomConfirmation
  },
  {
    label: "shared.common.confirmationLetterTemp",
    onClick: async () => {
      bus.emit("showCustomConfirmationPop");
    },
    show: getShowCustomConfirmation
  },
  {
    label: "shared.auth.logout",
    onClick: async () => {
      const userStore = useUserStoreHook();
      userStore.logout();
    }
  }
];
